<template>
  <layout-main-inner
    v-loading="loading"
    title="标签发放记录">
    <layout-card-wrap hasSlot>
      <template slot="form">
        <room-select v-model="config.roomId" />
        <el-button
          style="margin-left: 10px;"
          type="primary"
          @click="handleCurrentChange(1)">刷新</el-button>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="鉴定中心"
          min-width="240"
          prop="roomName"></el-table-column>
        <el-table-column
          label="标签序号"
          min-width="180"
          prop="beginTagNo">
          <template slot-scope="{ row }">{{ row.beginTagNo | tagCount() }}-{{ row.endTagNo | tagCount() }}</template>
        </el-table-column>
        <el-table-column
          label="发放数量"
          width="130"
          prop="tagCount"></el-table-column>
        <el-table-column
          label="未使用数量"
          width="130"
          :formatter="row => row.tagCount - row.usedTagCount"
          prop="usedTagCount"></el-table-column>
        <el-table-column
          label="发放时间"
          width="150">
          <template slot-scope="{ row }">{{ row.createdTime | dateformat() }}</template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="80">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              @click="cancelAllocationLabel(row)">取消分配</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"></el-pagination>
    </layout-card-wrap>
  </layout-main-inner>
</template>
<script>
import AppraiseLable from '../../../service/appraiseLable'
import RoomSelect from '../room-select.vue'
export default {
  name: 'LabelAllocation',
  components: { RoomSelect },
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      config: { pageNum: 1, pageSize: 10, roomId: null }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    additem() {
      this.$refs.production.init()
    },
    allocationLabel(row) {
      const { beginTagNo: min, endTagNo: max, notAssignTagCount: maxAssignCount, tagSegId } = row
      this.$refs.allocation.init({ min, max, maxAssignCount }, { tagSegId })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.fetchList()
    },
    cancelAllocationLabel(row) {
      this.$confirm('是否取消分配?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          AppraiseLable.deletetagassign({ tagAssignId: row.tagAssignId })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.$message.success('取消成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    fetchList() {
      this.loading = true
      AppraiseLable.gettagassigns({ ...this.config })
        .then(res => {
          this.loading = false
          const { result, message, records, total } = res.data
          if ([0, 13].includes(result)) {
            this.list = records
            this.total = total
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
